"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldContainer = exports.defaultLabelRenderer = exports.FieldContainerDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var field_label_1 = require("../forms/field-label");
var form_field_id_1 = require("../../utils/form-field-id");
exports.FieldContainerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    font-family: ", ";\n    font-size: ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n    font-family: ", ";\n    font-size: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(8), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE_FOR('base', 'normal'), function (props) {
    return props.marginless && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  })
});
var FieldLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    padding-left: 2px;\n  "], ["\n    padding-bottom: ", ";\n    padding-left: 2px;\n  "])), theme_1.theme.UNIT(2))
});
var ErrorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: ", ";\n    padding-left: 2px;\n    font-size: ", ";\n    font-weight: 500;\n    padding-left: ", ";\n    color: ", ";\n  "], ["\n    padding-top: ", ";\n    padding-left: 2px;\n    font-size: ", ";\n    font-weight: 500;\n    padding-left: ", ";\n    color: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(1), theme_1.theme.COLOR('error'))
});
var BGStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background-position: bottom left;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background-position: bottom left;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  FieldLabel: (0, styled_components_1.default)(field_label_1.FieldLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FieldLabelStyles),
  BG: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BGStyles),
  Error: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ErrorStyles)
};
exports.defaultLabelRenderer = My.FieldLabel;
var FieldContainer = function (props) {
  var className = props.className,
    field = props.field,
    children = props.children;
  var label = field.label,
    required = field.required,
    description = field.description,
    errorMessage = field.errorMessage;
  var LabelRenderer = field.labelRenderer || exports.defaultLabelRenderer;
  return React.createElement(My.Container, {
    marginless: props.marginless || field.marginless,
    name: (0, form_field_id_1.formFieldId)(field),
    className: className
  }, label && React.createElement(LabelRenderer, {
    field: field
  }), React.createElement(My.BG, null, children), errorMessage && React.createElement(My.Error, null, errorMessage));
};
exports.FieldContainer = FieldContainer;
exports.FieldContainer.defaultProps = exports.FieldContainerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;